import { DataGridLightTable } from '../data-grid-table';
import { DataGridLightCards } from '../data-grid-cards';
import { DataGridLightSettingsProvider } from '../provider-settings';
import {
  DataGridLightCardMode,
  DataGridLightClasses,
  DataGridLightColumn,
  DataGridLightDefaultTasks,
  DataGridLightRowProps,
} from '../../models';
import React from 'react';
import { DataGridTasksProvider } from '../provider-tasks';
import { useDataGridLightCardMode } from '../../hooks/use-data-grid-light-card-mode';

interface Props<T, Task extends DataGridLightDefaultTasks<T>> {
  className?: string;
  columns: DataGridLightColumn<T, any>[];
  rows: T[];
  rowKey?: keyof T;
  rowProps?: DataGridLightRowProps<T>;
  classes?: Partial<DataGridLightClasses>;
  onTask?: (task: Task) => void;
  /**
   * Phase F1 (D-10 / D-53; N2b, PD-10): the card list below md. Absent = the
   * automatic anatomy; `false` = the table at every viewport.
   */
  cardMode?: DataGridLightCardMode | false;
}

export const DataGridLight = <T, Task extends DataGridLightDefaultTasks<T>>({
  columns,
  rows,
  rowProps,
  rowKey,
  classes,
  onTask,
  cardMode,
}: Props<T, Task>) => {
  const isCardMode = useDataGridLightCardMode(cardMode);
  return (
    <DataGridTasksProvider onTask={onTask}>
      <DataGridLightSettingsProvider classes={classes}>
        {isCardMode && cardMode !== false ? (
          <DataGridLightCards
            cardMode={cardMode}
            columns={columns}
            rows={rows}
            rowKey={rowKey}
            rowProps={rowProps}
          />
        ) : (
          <DataGridLightTable columns={columns} rows={rows} rowKey={rowKey} rowProps={rowProps} />
        )}
      </DataGridLightSettingsProvider>
    </DataGridTasksProvider>
  );
};
